<template>
    <div class="reo-pagination">
        <button type="button" class="pagination-back" :disabled="myCurrentPage === 1" @click="prev">
            <span :class="['pagination-icon', 'icon-icon_back', {'disabled': myCurrentPage === 1}]"></span>
            <span class="show-on-small-screen">{{ $t('pagination.prev') }}</span>
        </button>
        <ul class="pagination-list">
            <li @click="changePage(1)" :class="[{'active': myCurrentPage === 1}]">1</li>
            <li class="ellipsis" v-show="showList.flag === 'max' || showList.flag === 'mid'">...</li>
            <li v-for="num in showList.value" :key="num" @click="changePage(num)" :class="[{'active': myCurrentPage === num}]">{{num}}</li>
            <li class="ellipsis" v-show="showList.flag === 'min' || showList.flag === 'mid'">...</li>
            <li @click="changePage(pageCount)" v-show="pageCount > 7" :class="[{'active': myCurrentPage === pageCount}]">{{pageCount}}</li>
        </ul>
        <button type="button" class="pagination-forward" :disabled="myCurrentPage === pageCount" @click="next">
            <span class="show-on-small-screen">{{ $t('pagination.next') }}</span>
            <span :class="['pagination-icon', 'icon-icon_back', 'icon-icon_back-wrap', {'disabled': myCurrentPage === pageCount}]"></span>
        </button>
        <span class="pagination-jump">
            {{ $t('pagination.jump') }}
            <input type="number" autocomplete="off" min="1" max="10" class="pagination-editor" v-model.number="currentPageEdit" @change="goPage">
            {{ $t('pagination.page') }}
        </span>
    </div>
</template>

<script>
export default {
    props: {

        total: Number,
        pageSize: Number,
        currentPage: {
            type: Number,
            default () {

                return 1;

            }
        }

    },
    data () {
        
        return {
            
            myCurrentPage: this.currentPage,
            currentPageEdit: this.currentPage,
            showLength: 5

        };

    },
    methods: {

        changePage ( page ) {

            this.myCurrentPage = page;

        },
        goPage () {

            let currentPageEdit = Math.floor( this.currentPageEdit );
            if ( currentPageEdit > this.pageCount ) {

                currentPageEdit = this.pageCount;

            } else if ( currentPageEdit < 0 ) {

                currentPageEdit = this.myCurrentPage;

            }
            this.currentPageEdit = currentPageEdit;
            this.changePage( currentPageEdit );

        },
        prev () {

            if ( this.myCurrentPage !== 1 ) {

                this.myCurrentPage -= 1;

            }

        },
        next () {

            if ( this.myCurrentPage !== this.pageCount ) {

                this.myCurrentPage += 1;

            }

        }

    },
    computed: {

        pageCount () {

            let { total, pageSize } = this;
            return Math.ceil( total / pageSize );

        },
        showList () {

            let { myCurrentPage, pageCount, showLength } = this;
            let base = 4;
            let showList = [];
            let min;
            let max;
            let flag;
            if ( pageCount === 1 ) {

                flag = null;
                return {
                    value: [],
                    flag
                };

            } else if ( pageCount < showLength + 3 ) {

                for ( let num = 2; num < pageCount + 1; num++ ) {

                    showList.push( num );

                }
                flag = null;
                return {
                    value: showList,
                    flag
                };

            } else if ( myCurrentPage < showLength ) {

                flag = 'min';
                base = 4;

            } else if ( myCurrentPage > pageCount - showLength ) {

                flag = 'max';
                base = pageCount - Math.ceil( showLength / 2 );

            } else {

                flag = 'mid';
                base = myCurrentPage;

            }
            min = base - Math.floor( showLength / 2 );
            max = base + ( showLength - Math.floor( showLength / 2 ) - 1 );
            for ( let num = min; num < max + 1; num++ ) {

                showList.push( num );

            }
            return {
                value: showList,
                flag
            };

        }

    },
    watch: {

        currentPage ( currentPage ) {

            this.myCurrentPage = currentPage;

        },
        myCurrentPage ( myCurrentPage ) {

            this.currentPageEdit = myCurrentPage;
            this.$emit( 'pageChange', myCurrentPage );

        }

    }
};
</script>

<style lang="less">
 .icon-icon_back-wrap{
    display: inline-block;
    transform: rotate(180deg);
}
.reo-pagination *{
    font-weight: 500;
}
button.pagination-forward,
button.pagination-back{
    background: 50% no-repeat;
    background-color: #fff;
    cursor: pointer;
    margin: 0;
    border: none;
    position: relative;
    color: #333;
    font-weight: 500;
    display: inline-block;
    top: -2px;
    font-size: 14px;
}
button.pagination-forward:disabled,
button.pagination-back:disabled,
.pagination-icon.icon-icon_back-wrap.disabled,
.pagination-icon.icon-icon_back.disabled{
    color: #ccc !important;
    cursor: auto;
}
button.pagination-back{
    padding: .1rem .7rem .1rem .1rem;
}
button.pagination-forward{
    padding: .1rem  .1rem  .1rem .7rem;
}
.reo-pagination .pagination-icon{
    cursor:pointer;
    margin: 0 0.1rem;
}
.reo-pagination .pagination-back:hover,
.reo-pagination .pagination-forward:hover{
    color: @theme;
}
.pagination-list{
    display: inline;
}
.pagination-list li{
    border-radius: 100%;
    display: inline-block;
    text-align: center;
    color: #333;
    font-weight: 500;
    line-height: 34px;
    width: 34px;
    position: relative;
    top: -1px;
}
.pagination-list li:not(.ellipsis):hover,
.pagination-list li.active{
    cursor: pointer;
    background-color: #f3f4f9;
    color: @theme;
}
.reo-pagination{
    font-size: 14px;
    text-align: center;
    margin: .6rem auto;
    position: relative;
}

.pagination-editor{
    box-shadow: none;
    outline: none;
    border-radius: 20px;
    border: 1px solid #777;
    padding: 2px .5em;
    margin-left: .1rem;
    margin-right: .1rem;
    text-align: center;
    width: 1rem;
    max-width: 60px;
    box-sizing: border-box;
}
.pagination-jump{
    margin-left:.6rem;
    position: relative;
    top: -2px;
}
@media only screen and (max-width: 1199px ) {
    .reo-pagination,
    .pagination-editor{
        font-size: 0.24rem;
    }
    .pagination-jump{
        display: block;
        margin-top: .2rem;
        margin-left: 0;
    }
    button.pagination-back{
        padding-right: .2rem;
        font-size: 0.24rem;
    }
    button.pagination-forward{
        padding-left: .2rem;
        font-size: 0.24rem;
    }
}
input[type="number"] {
    -moz-appearance: textfield;
    -webkit-appearance: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}
@media screen and (max-width: 767px){
    .show-on-small-screen{
        display: none;
    }
}
@media screen and (max-width: 349px) {
    .pagination-icon.icon-icon_back,
    .pagination-icon.icon-icon_back{
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/Pagination.vue